import { useState } from 'react'

export interface UseModalResult {
  isVisible: boolean
  openModal: () => void
  closeModal: () => void
  toggleModal: () => void
}

const useModal = (): UseModalResult => {
  const [isVisible, setIsVisible] = useState(false)

  const openModal = () => setIsVisible(true)
  const closeModal = () => setIsVisible(false)
  const toggleModal = () => setIsVisible((prev) => !prev)

  return {
    isVisible,
    openModal,
    closeModal,
    toggleModal
  }
}

export default useModal
